/**
 * Kept apart from `app.routes.ts`, which imports every routed component: a component reading
 * these paths from there closes an import cycle, and whichever module loads first then sees
 * the other's exports as `undefined`.
 */
export const AppRoutes = {
  home: '',
  login: 'login',
  accessDenied: 'access-denied',
  dataspace: {
    root: 'ds/:dataspaceId',
    params: {
      dataspaceId: 'dataspaceId'
    }
  },
  data: {
    root: 'data',
    view: {
      path: ':entity',
      params: {
        entity: 'entity'
      }
    },
    dataUpload: 'upload',
    new: {
      path: 'new/:mode',
      params: {
        mode: 'mode'
      }
    },
    edit: {
      path: 'edit/:entityUid/:mode',
      params: {
        entityUid: 'entityUid',
        mode: 'mode'
      }
    },
    customGeneration: {
      path: 'custom-gen/:genName',
      params: {
        genName: 'genName'
      },
      buildPath: (genName: string) => `custom-gen/${genName}`
    }
  },
  planData: {
    root: 'data',
    view: {
      path: ':entity',
      params: {
        entity: 'entity'
      }
    },
    new: {
      path: 'new/:mode',
      params: {
        mode: 'mode'
      }
    },
    edit: {
      path: 'edit/:entityUid/:mode',
      params: {
        entityUid: 'entityUid',
        mode: 'mode'
      }
    }
  },
  solvers: {
    root: 'solvers',
    view: {
      path: ':solver',
      params: {
        solver: 'solver'
      }
    }
  },
  plan: {
    root: 'planning-spaces',
    plans: {
      path: ':planningSpaceId',
      params: {
        planningSpaceId: 'planningSpaceId'
      },
      view: {
        path: 'plan/:planId',
        params: {
          planId: 'planId'
        },
        entity: {
          path: ':entity',
          params: {
            entity: 'entity'
          }
        },
        deploy: {
          path: 'deploy'
        }
      }
    }
  },
  optimizations: {
    root: 'optimizations'
  },
  reporting: {
    root: 'reporting'
  },
  admin: {
    root: 'admin',
    users: 'admin/users',
    apiKeys: 'admin/api-keys'
  },
  profile: {
    root: 'profile',
    info: 'profile/info',
    apiKeys: 'profile/api-keys',
    security: 'profile/security'
  },
  settings: {
    root: 'settings'
  },
  user: {
    root: 'user'
  },
  dataVisualizationPopup: {
    root: 'data-visualization'
  },
  assistantWindow: {
    root: 'chat-window'
  }
};
